var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "tabs" } },
    [
      _vm._l(_vm.content, function (tabData, index) {
        return _c(
          "button",
          {
            key: tabData.id,
            class: {
              "tab-button tab-button-override active active_tab_class":
                _vm.currentTab === tabData.id,
              "tab-button tab-button-override inactive":
                _vm.currentTab != tabData.id,
              "custom-shadow": index === _vm.content.length - 1,
            },
            on: {
              click: function ($event) {
                return _vm.selectTab(tabData.id)
              },
            },
          },
          [_vm._v(_vm._s(tabData.title))]
        )
      }),
      _c("div", { staticClass: "noselect doc-viewer" }, [
        _c(
          "div",
          { staticClass: "wrapper-div" },
          [
            _vm._l(_vm.content, function (tabData) {
              return [
                _vm.currentTab === tabData.id
                  ? _c("div", { key: tabData.id }, [
                      _vm.displayPdf && _vm.sasToken
                        ? _c(
                            "div",
                            { staticClass: "pdf-div" },
                            [
                              _c("PDFViewer", {
                                attrs: { url: tabData.content + _vm.sasToken },
                                on: { "document-errored": _vm.documentErrored },
                              }),
                            ],
                            1
                          )
                        : _c("h3", [_vm._v("File Not present")]),
                    ])
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }